export default __webpack_public_path__ + "static/media/yanbal.fed6c02d.png";